import React from 'react';
import cc from 'classcat';
import { Card as BPCard, CardProps as ICardProps } from '@blueprintjs/core';

interface CardProps extends ICardProps {
  faded?: boolean;
}

const Card: React.FC<CardProps> = (props) => {
  const classes = cc([props.className, props.faded ? 'bp5-card-faded' : null]);
  return <BPCard {...props} className={classes} />;
};

export default Card;

export const CardFrame: React.FC<ICardProps> = (props) => {
  return (
    <Card
      {...props}
      style={Object.assign({}, props.style, {
        padding: 0
      })}
    />
  );
};

export interface CardBlockProps {
  className?: string;
  bare?: boolean;
}

export const CardBlock: React.FC<CardBlockProps> = (props) => {
  const { bare, className, ..._props } = props;
  const classes = cc([
    className,
    'bp5-card-block',
    bare ? 'bp5-card-block-bare' : null
  ]);
  return <div className={classes} {..._props} />;
};

export const CardTitle: React.FC<{ className?: string }> = (props) => {
  const { className, ..._props } = props;
  const classes = cc([className, 'bp5-card-block', 'bp5-card-title']);
  return <div className={classes} {..._props} />;
};

export interface CardBreakoutProps {
  className?: string;
  right?: boolean;
}

export const CardBreakout: React.FC<CardBreakoutProps> = (props) => {
  const { right, className, ..._props } = props;
  const classes = cc([
    className,
    'bp5-card-breakout',
    right ? 'bp5-card-breakout-right' : null
  ]);
  return <div className={classes} {..._props} />;
};
